import { Download } from "lucide-react";
import { asset } from "@/lib/api";

export const MediaPlayer = ({ item, index }) => {
  const src = asset(item.url);
  const tid = `media-${item.kind}-${index}`;
  if (item.kind === "video")
    return <video data-testid={tid} src={src} controls preload="metadata" className="w-full rounded-xl bg-black aspect-video" />;
  if (item.kind === "audio")
    return (
      <div className="rounded-xl bg-white/5 border border-white/10 p-3">
        <div className="text-xs text-slate-400 mb-2 truncate">{item.name}</div>
        <audio data-testid={tid} src={src} controls preload="metadata" className="w-full" />
      </div>
    );
  if (item.kind === "image") return <img data-testid={tid} src={src} alt={item.name} className="w-full rounded-xl" />;
  const isPdf = (item.content_type || "").includes("pdf");
  const viewer = isPdf ? src : `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(src)}`;
  return (
    <div className="rounded-xl border border-white/10 overflow-hidden" data-testid={tid}>
      <iframe title={item.name} src={viewer} className="w-full aspect-[4/3] bg-white" />
      <a href={src} target="_blank" rel="noreferrer" data-testid={`${tid}-download`}
        className="flex items-center gap-2 px-3 py-2 text-xs text-amber-300 hover:bg-white/5"><Download className="h-3.5 w-3.5" /> Open / download {item.name}</a>
    </div>
  );
};
